<div *ngFor="let menu of parentMenu" class="menu-item">
  <a *ngIf="menu.routerLink && !menu.hasSubMenu && !menu.newTab"
     [routerLink]="[menu.routerLink]" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
     [title]="menu.title" [id]="'menu-item-'+menu.id">
    <span class="menu-icon svg-icon" *ngIf="menu.icon" [innerHTML]="getSvgIcon(menu.icon)"></span>
    <span class="menu-title">{{menu.title}}</span>
  </a>

  <a *ngIf="menu.href && !menu.hasSubMenu && menu.newTab"
     [href]="menu.href" target="_blank"
     [title]="menu.title" [id]="'menu-item-'+menu.id">
    <span class="menu-icon svg-icon" *ngIf="menu.icon" [innerHTML]="getSvgIcon(menu.icon)"></span>
    <span class="menu-title">{{menu.title}}</span>
  </a>

  <a *ngIf="menu.hasSubMenu"
     role="button" tabindex="0"
     [title]="menu.title" (click)="onClick(menu.id)"
     (keydown.enter)="onClick(menu.id)" (keydown.space)="onClick(menu.id)"
     [id]="'menu-item-'+menu.id">
    <span class="menu-icon svg-icon" *ngIf="menu.icon" [innerHTML]="getSvgIcon(menu.icon)"></span>
    <span class="menu-title">{{menu.title}}</span>
    <span class="menu-expand-icon">▼</span>
  </a>

  <div *ngIf="menu.hasSubMenu" class="sub-menu" [id]="'sub-menu-'+menu.id" (click)="logmenu($event)">
    <app-vertical-menu [menuItems]="menuItems" [menuParentId]="menu.id"></app-vertical-menu>
  </div>
</div>
